import { Env } from 'core';

interface h5LoginConfig {
  appid: number;
  role: number;
  lang: string;
  city_id: number;
  country_calling_code: string;
  country_id: number;
}

interface CountryConfig {
  [key: string]: {
    html_default_title: string; // app 兜底标题
    driver_info_list: Array<string>;
    show_ledger_rules: boolean; // 分账规则
    phone_format_check: string; // 手机号正则
    country_calling_code: string; // 手机号开头
    add_driver_open: boolean; // 是否存在添加司机入口
    add_driver_ledger: boolean; // 是否跳转2.0添加司机页
    driver_bind_car_open: boolean; // 是否存在司机绑定车辆入口
    add_car_open: boolean; // 是否存在添加车辆入口
    app_bundle_id: string; // bundle_id
    deposit_deatil_tab: number;
    feedback_html_key: string; // 个人中心 -> 评分页面key
    summary_download: string; // 加下报表接口
    show_leader_card: boolean;
    show_add_document: boolean; // 展示个人中心->添加文档
    help_email: string;
    h5_login_config: h5LoginConfig;
    h5_page_hash: any[];
    bankCode: string;
    fleet_profile: {
      show_bank_account: boolean;
      bank_url: string;
      bank_query: any;
      show_invoice_info: boolean;
    };
    maxRange: number;
  };
}

const countryConfig: CountryConfig = {
  BR: {
    html_default_title: '99',
    driver_info_list: ['id_no', 'cell', 'reg_city', 'reg_date'],
    show_ledger_rules: true,
    phone_format_check: '(^[0-9]{10,11}$)|(^0001[0-9]{7}$)',
    country_calling_code: '+55',
    add_driver_open: false,
    add_driver_ledger: true,
    driver_bind_car_open: false,
    add_car_open: false,
    app_bundle_id: 'com.app99.fleet',
    deposit_deatil_tab: 1,
    feedback_html_key: '23ebefb8cbdc009fca5ee2029291779f',
    summary_download: 'summaryListDownload',
    show_leader_card: false,
    show_add_document: false,
    help_email: '',
    h5_login_config: {
      appid: 200017, // 自己申请的appid
      role: 2,
      lang: 'pt-BR',
      city_id: 0,
      country_calling_code: '+55',
      country_id: 76,
    },
    h5_page_hash: ['/driver/driverJoinFleet', '/headpic'],
    bankCode: 'dlocal',
    fleet_profile: {
      show_bank_account: true,
      bank_url: Env.ADD_BANK_99,
      bank_query: {},
      show_invoice_info: false,
    },
    maxRange: 90,
  },
  MX: {
    html_default_title: 'Fleet',
    driver_info_list: ['id_no', 'cell', 'reg_city', 'reg_date'],
    show_ledger_rules: false,
    phone_format_check: '(^[0-9]{10}$)|(^0001[0-9]{7}$)',
    country_calling_code: '+52',
    add_driver_open: true,
    add_driver_ledger: false,
    driver_bind_car_open: true,
    add_car_open: true,
    app_bundle_id: 'com.didiglobal.fleet',
    deposit_deatil_tab: 2,
    feedback_html_key: 'b9523a2e8c95c1bab6f1b83662924ee3',
    summary_download: 'getIncomeSummary',
    show_leader_card: true,
    show_add_document: true,
    help_email: 'help.driver@mx.didiglobal.com',
    h5_login_config: {
      appid: 120022, // 自己申请的appid
      role: 2,
      lang: 'es-MX',
      city_id: 0,
      country_calling_code: '+52',
      country_id: 484,
    },
    h5_page_hash: ['/driver/driverJoinFleet', '/headpic'],
    bankCode: 'CITI',
    fleet_profile: {
      show_bank_account: true,
      bank_url: Env.ADD_BANK_MX,
      bank_query: {},
      show_invoice_info: true,
    },
    maxRange: 30,
  },
  CL: {
    html_default_title: 'Fleet',
    driver_info_list: ['id_no', 'cell', 'reg_city', 'reg_date'],
    show_ledger_rules: false,
    phone_format_check: '(^[0-9]{10}$)|(^0001[0-9]{7}$)',
    country_calling_code: '+56',
    add_driver_open: false,
    add_driver_ledger: false,
    driver_bind_car_open: true,
    add_car_open: true,
    app_bundle_id: 'com.didiglobal.fleet',
    deposit_deatil_tab: 2,
    feedback_html_key: 'b9523a2e8c95c1bab6f1b83662924ee3',
    summary_download: 'getIncomeSummary',
    show_leader_card: true,
    show_add_document: true,
    help_email: '',
    h5_login_config: {
      appid: 120022, // 自己申请的appid
      role: 2,
      lang: 'es-MX',
      city_id: 0,
      country_calling_code: '+56',
      country_id: 152,
    },
    h5_page_hash: ['/driver/driverJoinFleet', '/headpic'],
    bankCode: 'DLOCAL',
    fleet_profile: {
      show_bank_account: true,
      bank_url: Env.ADD_BANK,
      bank_query: {
        entryType: 2,
      },
      show_invoice_info: false,
    },
    maxRange: 90,
  },
  CO: {
    html_default_title: 'Fleet',
    driver_info_list: ['id_no', 'cell', 'reg_city', 'reg_date'],
    show_ledger_rules: false,
    phone_format_check: '(^[0-9]{10}$)|(^0001[0-9]{7}$)',
    country_calling_code: '+57',
    add_driver_open: true,
    add_driver_ledger: false,
    driver_bind_car_open: true,
    add_car_open: true,
    app_bundle_id: 'com.didiglobal.fleet',
    deposit_deatil_tab: 2,
    feedback_html_key: 'b9523a2e8c95c1bab6f1b83662924ee3',
    summary_download: 'getIncomeSummary',
    show_leader_card: true,
    show_add_document: true,
    help_email: 'conductor@co.didiglobal.com',
    h5_login_config: {
      appid: 120022,
      role: 2,
      lang: 'es-MX',
      city_id: 0,
      country_calling_code: '+57',
      country_id: 170,
    },
    h5_page_hash: ['/driver/driverJoinFleet', '/headpic'],
    bankCode: 'DLOCAL',
    fleet_profile: {
      show_bank_account: true,
      bank_url: Env.ADD_BANK,
      bank_query: {
        entryType: 2,
      },
      show_invoice_info: false,
    },
    maxRange: 90,
  },
  CR: {
    html_default_title: 'Fleet',
    driver_info_list: ['id_no', 'cell', 'reg_city', 'reg_date'],
    show_ledger_rules: false,
    phone_format_check: '(^[0-9]{10}$)|(^0001[0-9]{7}$)',
    country_calling_code: '+506',
    add_driver_open: true,
    add_driver_ledger: false,
    driver_bind_car_open: true,
    add_car_open: true,
    app_bundle_id: 'com.didiglobal.fleet',
    deposit_deatil_tab: 2,
    feedback_html_key: 'b9523a2e8c95c1bab6f1b83662924ee3',
    summary_download: 'getIncomeSummary',
    show_leader_card: true,
    show_add_document: true,
    help_email: '',
    h5_login_config: {
      appid: 120022,
      role: 2,
      lang: 'es-MX',
      city_id: 0,
      country_calling_code: '+506',
      country_id: 188,
    },
    h5_page_hash: ['/driver/driverJoinFleet', '/headpic'],
    bankCode: 'DLOCAL',
    fleet_profile: {
      show_bank_account: false,
      bank_url: Env.ADD_BANK,
      bank_query: {
        entryType: 2,
      },
      show_invoice_info: false,
    },
    maxRange: 90,
  },
  PE: {
    html_default_title: 'Fleet',
    driver_info_list: ['id_no', 'cell', 'reg_city', 'reg_date'],
    show_ledger_rules: false,
    phone_format_check: '(^[0-9]{10}$)|(^0001[0-9]{7}$)',
    country_calling_code: '+51',
    add_driver_open: false,
    add_driver_ledger: false,
    driver_bind_car_open: true,
    add_car_open: true,
    app_bundle_id: 'com.didiglobal.fleet',
    deposit_deatil_tab: 2,
    feedback_html_key: 'b9523a2e8c95c1bab6f1b83662924ee3',
    summary_download: 'getIncomeSummary',
    show_leader_card: true,
    show_add_document: true,
    help_email: '',
    h5_login_config: {
      appid: 120022, // 自己申请的appid
      role: 2,
      lang: 'es-MX',
      city_id: 0,
      country_calling_code: '+51',
      country_id: 604,
    },
    h5_page_hash: ['/driver/driverJoinFleet', '/headpic'],
    bankCode: 'DLOCAL',
    fleet_profile: {
      show_bank_account: true,
      bank_url: Env.ADD_BANK,
      bank_query: {
        entryType: 2,
      },
      show_invoice_info: false,
    },
    maxRange: 90,
  },
  AR: {
    html_default_title: 'Fleet',
    driver_info_list: ['id_no', 'cell', 'reg_city', 'reg_date'],
    show_ledger_rules: false,
    phone_format_check: '(^[0-9]{10}$)|(^0001[0-9]{7}$)',
    country_calling_code: '+54',
    add_driver_open: true,
    add_driver_ledger: false,
    driver_bind_car_open: true,
    add_car_open: true,
    app_bundle_id: 'com.didiglobal.fleet',
    deposit_deatil_tab: 2,
    feedback_html_key: 'b9523a2e8c95c1bab6f1b83662924ee3',
    summary_download: 'getIncomeSummary',
    show_leader_card: true,
    show_add_document: true,
    help_email: '',
    // AR 暂无，开区需要配置，MX 配置兜底
    h5_login_config: {
      appid: 120022,
      role: 2,
      lang: 'es-MX',
      city_id: 0,
      country_calling_code: '+54',
      country_id: 484,
    },
    h5_page_hash: ['/driver/driverJoinFleet', '/headpic'],
    bankCode: '',
    fleet_profile: {
      show_bank_account: true,
      bank_url: Env.ADD_BANK,
      bank_query: {
        entryType: 2,
      },
      show_invoice_info: false,
    },
    maxRange: 90,
  },
};

export default countryConfig;
